<template>
  <!-- MODALE AJOUT/MODIFICATION -->
  <b-modal
    body-class="poste-livraison-informations"
    v-if="poste"
    id="modal-show-poste-livraison"
    size="md"
    :title="`Fiche du poste de livraison ${poste.id}`"
    title-class="poste-livraison-informations__title"
  >
    <b-row>
      <!-- Localisation -->
      <b-col class="mb-sm-3 mb-md-0 poste-livraison-map">
        <b-card title="Localisation">
          <hr />
          <!-- Map -->
          <card class="m-0 p-0 poste-livraison-map__card">
            <div class="map poste-livraison-map__window" slot="image">
              <l-map :zoom="mapZoom" :center="mapCenter">
                <l-tile-layer
                  :url="baseLayer.url"
                  :attribution="baseLayer.attribution"
                ></l-tile-layer>
                <l-marker
                  v-for="(marker, index) in markers"
                  :key="index"
                  :lat-lng="marker"
                >
                  <l-icon
                    :icon-size="[25, 41]"
                    :icon-anchor="[12, 41]"
                    :icon-url="iconUrl"
                  >
                  </l-icon>
                </l-marker>
              </l-map>
            </div>
          </card>
          <!-- Infos -->
          <b-card-text class="mt-3">
            <h5 class="mb-2 info-coordinate-title">Coordonnées <span>{{ parc.projection.libelle }}</span></h5>
            <ul class="list-unstyled">
              <li class="m-2" v-if="poste.xposteLivraison"
              >X : {{ poste.xposteLivraison }}
              </li>
              <li v-else class="m-2 empty-field">
                {{ emptyfield }}
              </li>
              <li class="m-2" v-if="poste.yposteLivraison "
              >Y : {{ poste.yposteLivraison }}
              </li>
              <li v-else class="m-2 empty-field">
                {{ emptyfield }}
              </li>
            </ul>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <template #footer="{cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->

      <b-button
        variant="default"
        title="Revenir sur le panneau d'administration."
        @click="cancel()"
      >
        Retour
      </b-button>
    </template>
  </b-modal>
</template>
<script setup>
import { LMap, LTileLayer, LMarker, LIcon } from "@vue-leaflet/vue-leaflet";
import {BModal, BButton, BCardText, BCol, BRow, BCard} from "bootstrap-vue-next";

import {useReactiveStoreGetters} from "@/composables/useStore";
import {ref} from "vue";

// Data
const emptyfield = ref("Non renseigné(e)");

defineProps({
  poste: {
    type: [Object, null],
    required: true,
  },
  mapZoom: {
    type: Number,
    required: true,
  },
  mapCenter: {
    required: true,
  },
  markers: {
    type: Array,
    required: true,
  },
  iconUrl: String
})

const { parc, baseLayer } = useReactiveStoreGetters(["parc", "baseLayer"]);

</script>
<style lang="scss">
.poste-livraison-informations {
  background: #f4f3ef;
  &__title {
    font-size: 1.6rem;
    margin-bottom: 0;
    margin-left: 6px;
  }

  .empty-field {
    font-style: italic;
    font-size: 0.9em;
  }
}
.poste-livraison-map {
  &__card {
    height: 250px;
  }
  &__window {
    height: 250px;
  }
  & > .card {
    height: 100%;
  }
}
</style>
